import {RepositoryFactory} from '@/app/repositories/repository-factory.js';
// import Repository from '@/app/repositories/repository'

const uomRepository = RepositoryFactory.get('uom');

import allUOM from "../../store.product/data/all-uom.json"

export default Object.assign(uomRepository, {
    // addOrder : function(items){
    //     return Repository.post(`/order/createOrder`, items);
    // }
    getAllData: function () {
        return Promise.resolve({
        data: allUOM
        });
    },
});
